import React from 'react';
import './categoryIcons.css';

const stroke = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

const GlyphFrame = ({ label, children }) => (
  <svg viewBox="0 0 80 80" className="category-glyph" role="img" aria-label={label}>
    {children}
  </svg>
);

const GLYPHS = {
  photography: () => (
    <GlyphFrame label="Photography">
      <path d="M30 26l3.5-6h13L50 26" {...stroke} />
      <rect x="16" y="26" width="48" height="32" rx="8" {...stroke} />
      <circle cx="40" cy="42" r="9" {...stroke} />
      <circle className="cat-pulse" cx="40" cy="42" r="3.2" fill="currentColor" stroke="none" />
      <circle className="cat-accent cat-twinkle" cx="55" cy="33" r="1.8" fill="currentColor" stroke="none" />
    </GlyphFrame>
  ),
  video: () => (
    <GlyphFrame label="Video">
      <rect x="14" y="28" width="52" height="26" rx="7" {...stroke} />
      <g className="cat-spin">
        <circle cx="28" cy="41" r="7" {...stroke} />
        <path d="M28 35.5v11M22.5 41h11" {...stroke} />
      </g>
      <g className="cat-spin">
        <circle cx="52" cy="41" r="7" {...stroke} />
        <path d="M52 35.5v11M46.5 41h11" {...stroke} />
      </g>
    </GlyphFrame>
  ),
  planning: () => (
    <GlyphFrame label="Planning">
      <rect x="24" y="16" width="32" height="48" rx="5" {...stroke} />
      <rect x="34" y="12" width="12" height="8" rx="2" {...stroke} />
      <path className="cat-draw" d="M32 40l5 5 12-13" {...stroke} />
    </GlyphFrame>
  ),
  catering: () => (
    <GlyphFrame label="Catering">
      <path className="cat-rise cat-accent" d="M33 24c0-5 2-8 2-8M47 22c0-6 2-8 2-8" {...stroke} />
      <path d="M24 54h32" {...stroke} />
      <path d="M28 54c0-16 6-24 12-24s12 8 12 24" {...stroke} />
      <circle cx="40" cy="28" r="1.7" fill="currentColor" stroke="none" />
    </GlyphFrame>
  ),
  music: () => (
    <GlyphFrame label="Music">
      <g className="cat-spin-slow">
        <circle cx="34" cy="44" r="16" {...stroke} />
        <circle cx="34" cy="44" r="5" {...stroke} />
        <circle cx="34" cy="44" r="1.6" fill="currentColor" stroke="none" />
      </g>
      <path d="M50 22v26" {...stroke} />
      <path d="M50 22l12 4v8l-12-4" {...stroke} />
    </GlyphFrame>
  ),
  decor: () => (
    <GlyphFrame label="Decoration">
      <path d="M18 60V38c0-14 9-22 22-22s22 8 22 22v22" {...stroke} />
      <path d="M18 60h44" {...stroke} />
      <g className="cat-twinkle cat-accent">
        <path d="M40 32v10M35 37h10" {...stroke} />
      </g>
    </GlyphFrame>
  ),
  transport: () => (
    <GlyphFrame label="Transportation">
      <path d="M14 44h52l-6-14H24L14 44z" {...stroke} />
      <path d="M18 44v6h44v-6" {...stroke} />
      <g className="cat-spin">
        <circle cx="28" cy="52" r="6" {...stroke} />
        <path d="M28 48v8M24 52h8" {...stroke} />
      </g>
      <g className="cat-spin">
        <circle cx="54" cy="52" r="6" {...stroke} />
        <path d="M54 48v8M50 52h8" {...stroke} />
      </g>
    </GlyphFrame>
  ),
  venue: () => (
    <GlyphFrame label="Venue">
      <path d="M16 64V32l24-14 24 14v32" {...stroke} />
      <path d="M16 64h48" {...stroke} />
      <path d="M34 64V46h12v18" {...stroke} />
      <rect className="cat-glow cat-accent" x="24" y="38" width="7" height="7" rx="1" fill="currentColor" stroke="none" />
      <rect className="cat-glow" x="49" y="38" width="7" height="7" rx="1" fill="currentColor" stroke="none" />
    </GlyphFrame>
  ),
  wedding: () => (
    <GlyphFrame label="Wedding">
      <g className="cat-rock">
        <circle cx="32" cy="42" r="13" {...stroke} />
        <circle cx="48" cy="42" r="13" {...stroke} />
      </g>
      <circle className="cat-twinkle cat-accent" cx="40" cy="22" r="1.8" fill="currentColor" stroke="none" />
    </GlyphFrame>
  ),
  content: () => (
    <GlyphFrame label="Content">
      <rect x="26" y="12" width="28" height="56" rx="7" {...stroke} />
      <path d="M34 20h12" {...stroke} />
      <polygon className="cat-pulse" points="36,34 36,52 52,43" fill="currentColor" stroke="none" />
    </GlyphFrame>
  ),
  beauty: () => (
    <GlyphFrame label="Beauty">
      <circle cx="40" cy="36" r="16" {...stroke} />
      <path d="M26 54c5 8 23 8 28 0" {...stroke} />
      <circle className="cat-twinkle cat-accent" cx="48" cy="28" r="1.8" fill="currentColor" stroke="none" />
      <path d="M34 36h12" {...stroke} />
    </GlyphFrame>
  ),
  lighting: () => (
    <GlyphFrame label="Lighting">
      <path d="M40 12v8M26 20l5 7M54 20l-5 7" {...stroke} />
      <path d="M30 32h20l8 30H22z" {...stroke} />
      <path className="cat-beam cat-accent" d="M32 62l-6 10M48 62l6 10M40 62v10" {...stroke} />
    </GlyphFrame>
  ),
  floral: () => (
    <GlyphFrame label="Floral">
      <path d="M40 64V42" {...stroke} />
      <path d="M40 52c-8 2-12 0-14-4" {...stroke} />
      <g className="cat-bloom">
        <circle cx="40" cy="22" r="6" {...stroke} />
        <circle cx="50" cy="30" r="6" {...stroke} />
        <circle cx="30" cy="30" r="6" {...stroke} />
        <circle cx="40" cy="36" r="6" {...stroke} />
        <circle className="cat-accent" cx="40" cy="29" r="3" fill="currentColor" stroke="none" />
      </g>
    </GlyphFrame>
  ),
  booth: () => (
    <GlyphFrame label="Photo booth">
      <rect x="16" y="14" width="48" height="52" rx="5" {...stroke} />
      <path d="M16 28h48" {...stroke} />
      <path className="cat-curtain" d="M28 28c3 10 3 20 0 30" {...stroke} />
      <path className="cat-curtain" d="M40 28c3 12 3 22 0 30" {...stroke} />
      <path className="cat-curtain" d="M52 28c3 10 3 20 0 30" {...stroke} />
      <circle className="cat-pulse cat-accent" cx="40" cy="21" r="2" fill="currentColor" stroke="none" />
    </GlyphFrame>
  ),
  drone: () => (
    <GlyphFrame label="Drone">
      <path d="M32 42L22 30M48 42l10-12" {...stroke} />
      <rect x="30" y="38" width="20" height="12" rx="3" {...stroke} />
      <g className="cat-spin">
        <ellipse cx="22" cy="26" rx="11" ry="3.2" {...stroke} />
      </g>
      <g className="cat-spin">
        <ellipse cx="58" cy="26" rx="11" ry="3.2" {...stroke} />
      </g>
    </GlyphFrame>
  ),
  cake: () => (
    <GlyphFrame label="Cake">
      <path className="cat-flicker cat-accent" d="M40 24c0-4 2-6 0-10 2 4 0 6 0 10z" fill="currentColor" stroke="none" />
      <rect x="28" y="28" width="24" height="12" rx="2" {...stroke} />
      <rect x="20" y="40" width="40" height="16" rx="3" {...stroke} />
      <path d="M28 40v16M52 40v16" {...stroke} />
    </GlyphFrame>
  ),
  mark: () => (
    <GlyphFrame label="Category">
      <circle cx="40" cy="40" r="18" {...stroke} />
      <path className="cat-twinkle" d="M40 28v24M28 40h24" {...stroke} />
    </GlyphFrame>
  ),
};

export const CATEGORY_ICONS = [
  { id: 'photography', label: 'Photography', keywords: ['photo', 'camera', 'portrait'] },
  { id: 'booth', label: 'Photo booth', keywords: ['booth'] },
  { id: 'video', label: 'Video', keywords: ['video', 'film', 'cinema'] },
  { id: 'wedding', label: 'Wedding', keywords: ['wedding', 'bridal'] },
  { id: 'content', label: 'Content', keywords: ['content', 'creator', 'social'] },
  { id: 'planning', label: 'Planning', keywords: ['plan', 'coordinat'] },
  { id: 'catering', label: 'Catering', keywords: ['cater', 'food', 'chef', 'culinary'] },
  { id: 'music', label: 'Music', keywords: ['music', 'dj', 'band', 'entertain'] },
  { id: 'decor', label: 'Decoration', keywords: ['decor', 'styling', 'design'] },
  { id: 'floral', label: 'Floral', keywords: ['floral', 'flower'] },
  { id: 'transport', label: 'Transport', keywords: ['transport', 'car', 'limo', 'shuttle'] },
  { id: 'venue', label: 'Venue', keywords: ['venue', 'hall'] },
  { id: 'beauty', label: 'Beauty', keywords: ['beauty', 'makeup', 'hair', 'spa'] },
  { id: 'lighting', label: 'Lighting', keywords: ['light'] },
  { id: 'drone', label: 'Drone', keywords: ['drone', 'aerial'] },
  { id: 'cake', label: 'Cake', keywords: ['cake', 'bakery', 'dessert'] },
];

const ICON_IDS = new Set(CATEGORY_ICONS.map((icon) => icon.id));

export function parseIconId(iconUrl) {
  if (typeof iconUrl !== 'string' || !iconUrl.startsWith('icon:')) return null;
  const id = iconUrl.slice(5);
  return ICON_IDS.has(id) ? id : null;
}

export function isPlaceholderIconUrl(iconUrl) {
  if (!iconUrl || typeof iconUrl !== 'string') return true;
  if (iconUrl.startsWith('icon:')) return false;
  try {
    const host = new URL(iconUrl).hostname;
    return host === 'example.com' || host.endsWith('.example.com');
  } catch {
    return true;
  }
}

export function usableImageUrl(iconUrl) {
  if (!iconUrl || typeof iconUrl !== 'string') return null;
  if (iconUrl.startsWith('icon:')) return null;
  if (isPlaceholderIconUrl(iconUrl)) return null;
  return iconUrl;
}

const MATCH_PRIORITY = ['booth', 'wedding', 'content', 'video', 'drone', 'cake', 'floral', 'photography', 'planning', 'catering', 'music', 'decor', 'transport', 'venue', 'beauty', 'lighting'];

export function suggestIconId(category) {
  const name = `${category?.category_name || ''}`.toLowerCase();
  const icons = new Map(CATEGORY_ICONS.map((icon) => [icon.id, icon]));
  const matchId = MATCH_PRIORITY.find((id) => icons.get(id)?.keywords.some((word) => name.includes(word)));
  if (matchId) return matchId;

  const byType = {
    photo_video: 'photography',
    entertainment: 'music',
    event_services: 'planning',
    venue_services: 'venue',
    transportation: 'transport',
    beauty_wellness: 'beauty',
    wedding_services: 'wedding',
  };
  return byType[category?.service_type] || 'mark';
}

export function resolveCategoryIcon(category) {
  return parseIconId(category?.icon_url) || suggestIconId(category);
}

export function iconValue(id) {
  return id ? `icon:${id}` : '';
}

export function CategoryGlyph({ iconId = 'mark', className = '' }) {
  const Glyph = GLYPHS[iconId] || GLYPHS.mark;
  return (
    <span className={`inline-flex ${className}`.trim()}>
      <Glyph />
    </span>
  );
}

export function CategoryIconPicker({ value, onChange }) {
  return (
    <div className="grid grid-cols-4 gap-2 sm:grid-cols-8">
      {CATEGORY_ICONS.map((icon) => {
        const selected = value === icon.id;
        return (
          <button
            key={icon.id}
            type="button"
            onClick={() => onChange(icon.id)}
            className={`flex flex-col items-center gap-1 rounded-xl border px-1 py-2 transition-colors ${
              selected ? 'border-ink bg-surface-muted ring-1 ring-ink' : 'border-border bg-surface hover:border-ink/40'
            }`}
            aria-pressed={selected}
          >
            <span className="flex h-12 w-12 items-center justify-center">
              <CategoryGlyph iconId={icon.id} className="h-12 w-12" />
            </span>
            <span className="line-clamp-1 text-[10px] font-medium text-ink">{icon.label}</span>
          </button>
        );
      })}
    </div>
  );
}
